// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gdx/gateway/web/notification/v1/notification.proto (package gdx.gateway.web.notification.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Duration, Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";
import { RetentionActionResultEvent, RetentionRewardReceivedEvent, ReviewPopUpEvent } from "../../../../events/v1/events_pb.js";
import { ProfileGender, ProfilePhoto } from "../../profile/v1/profile_pb.js";
import { DialogMessage, RestrictionReason } from "../../chat/v1/dialogs_pb.js";
import { OrderStatus, PaymentGateway, PaymentOrderStatusDetails } from "../../payment/v2/payment_pb.js";
import { Subscription } from "../../payment/v2/subscription_pb.js";
import { PackageIdentity } from "../../payment/v2/package_pb.js";
import { FeatureType } from "../../../../market/v1/package_pb.js";
import { Possibility } from "../../possibilities/v1/possibilities_pb.js";

/**
 * Websocket notifications wrapper.
 *
 * @generated from message gdx.gateway.web.notification.v1.Notification
 */
export class Notification extends Message<Notification> {
  /**
   * @generated from field: string id = 5;
   */
  id = "";

  /**
   * @generated from oneof gdx.gateway.web.notification.v1.Notification.notification
   */
  notification: {
    /**
     * @generated from field: gdx.gateway.web.notification.v1.NotificationMatchFromUser match_from_user = 1;
     */
    value: NotificationMatchFromUser;
    case: "matchFromUser";
  } | {
    /**
     * @generated from field: gdx.gateway.web.notification.v1.NotificationMatchFromMe match_from_me = 2;
     */
    value: NotificationMatchFromMe;
    case: "matchFromMe";
  } | {
    /**
     * @generated from field: gdx.gateway.web.notification.v1.NotificationVisit visit = 3;
     */
    value: NotificationVisit;
    case: "visit";
  } | {
    /**
     * @generated from field: gdx.gateway.web.notification.v1.NotificationLike like = 4;
     */
    value: NotificationLike;
    case: "like";
  } | {
    /**
     * @generated from field: gdx.gateway.web.notification.v1.NotificationDialogMessage dialog_message = 12;
     */
    value: NotificationDialogMessage;
    case: "dialogMessage";
  } | {
    /**
     * @generated from field: gdx.gateway.web.notification.v1.NotificationLikesCountViewUpdated likes_count_view_updated = 15;
     */
    value: NotificationLikesCountViewUpdated;
    case: "likesCountViewUpdated";
  } | {
    /**
     * @generated from field: gdx.gateway.web.notification.v1.NotificationUnreadMessagesCountViewUpdated unread_messages_count_view_updated = 16;
     */
    value: NotificationUnreadMessagesCountViewUpdated;
    case: "unreadMessagesCountViewUpdated";
  } | {
    /**
     * @generated from field: gdx.gateway.web.notification.v1.NotificationDialogMessageDeleted dialog_message_deleted = 17;
     */
    value: NotificationDialogMessageDeleted;
    case: "dialogMessageDeleted";
  } | {
    /**
     * @generated from field: gdx.gateway.web.notification.v1.NotificationShowPromos show_promos = 19;
     */
    value: NotificationShowPromos;
    case: "showPromos";
  } | {
    /**
     * @generated from field: gdx.gateway.web.notification.v1.NotificationPaymentOrderStatusUpdate payment_order_status = 20;
     */
    value: NotificationPaymentOrderStatusUpdate;
    case: "paymentOrderStatus";
  } | {
    /**
     * @generated from field: gdx.gateway.web.notification.v1.NotificationDialogMessageRestricted dialog_message_restricted = 21;
     */
    value: NotificationDialogMessageRestricted;
    case: "dialogMessageRestricted";
  } | {
    /**
     * @generated from field: gdx.gateway.web.notification.v1.NotificationSubscriptionUpdated subscription_updated = 22;
     */
    value: NotificationSubscriptionUpdated;
    case: "subscriptionUpdated";
  } | {
    /**
     * @generated from field: gdx.gateway.web.notification.v1.NotificationSuspiciousContentReported suspicious_content_reported = 23;
     */
    value: NotificationSuspiciousContentReported;
    case: "suspiciousContentReported";
  } | {
    /**
     * @generated from field: gdx.gateway.web.notification.v1.NotificationBlockedByUser blocked_by_user = 24;
     */
    value: NotificationBlockedByUser;
    case: "blockedByUser";
  } | {
    /**
     * @generated from field: gdx.gateway.web.notification.v1.NotificationRequestPhoto request_photo = 25;
     */
    value: NotificationRequestPhoto;
    case: "requestPhoto";
  } | {
    /**
     * @generated from field: gdx.gateway.web.notification.v1.NotificationRequestPhotoUploaded request_photo_uploaded = 26;
     */
    value: NotificationRequestPhotoUploaded;
    case: "requestPhotoUploaded";
  } | {
    /**
     * @generated from field: gdx.gateway.web.notification.v1.NotificationBoosterActive booster_active = 27;
     */
    value: NotificationBoosterActive;
    case: "boosterActive";
  } | {
    /**
     * @generated from field: gdx.gateway.web.notification.v1.NotificationCreditsRefillSuccess credits_refill_success = 28;
     */
    value: NotificationCreditsRefillSuccess;
    case: "creditsRefillSuccess";
  } | {
    /**
     * @generated from field: gdx.gateway.web.notification.v1.NotificationCreditsRefillFail credits_refill_fail = 29;
     */
    value: NotificationCreditsRefillFail;
    case: "creditsRefillFail";
  } | {
    /**
     * @generated from field: gdx.gateway.web.notification.v1.NotificationCreditsUpdated credits_updated = 30;
     */
    value: NotificationCreditsUpdated;
    case: "creditsUpdated";
  } | {
    /**
     * @generated from field: gdx.gateway.web.notification.v1.NotificationSubscriptionPaymentSuccess subscription_payment_success = 31;
     */
    value: NotificationSubscriptionPaymentSuccess;
    case: "subscriptionPaymentSuccess";
  } | {
    /**
     * @generated from field: gdx.gateway.web.notification.v1.NotificationSubscriptionPaymentFailed subscription_payment_failed = 32;
     */
    value: NotificationSubscriptionPaymentFailed;
    case: "subscriptionPaymentFailed";
  } | {
    /**
     * @generated from field: gdx.gateway.web.notification.v1.NotificationDialogMessageV2 dialog_message_v2 = 33;
     */
    value: NotificationDialogMessageV2;
    case: "dialogMessageV2";
  } | {
    /**
     * @generated from field: gdx.gateway.web.notification.v1.NotificationSendPowerLikeSuccess send_power_like_success = 34;
     */
    value: NotificationSendPowerLikeSuccess;
    case: "sendPowerLikeSuccess";
  } | {
    /**
     * @generated from field: gdx.gateway.web.notification.v1.NotificationSendPowerLikeFail send_power_like_fail = 35;
     */
    value: NotificationSendPowerLikeFail;
    case: "sendPowerLikeFail";
  } | {
    /**
     * @generated from field: gdx.gateway.web.notification.v1.NotificationCompatibilitySuccess compatibility_success = 37;
     */
    value: NotificationCompatibilitySuccess;
    case: "compatibilitySuccess";
  } | {
    /**
     * @generated from field: gdx.gateway.web.notification.v1.NotificationCompatibilityFail compatibility_fail = 38;
     */
    value: NotificationCompatibilityFail;
    case: "compatibilityFail";
  } | {
    /**
     * @generated from field: gdx.gateway.web.notification.v1.NotificationSexualCompatibilitySuccess sexual_compatibility_success = 39;
     */
    value: NotificationSexualCompatibilitySuccess;
    case: "sexualCompatibilitySuccess";
  } | {
    /**
     * @generated from field: gdx.gateway.web.notification.v1.NotificationSexualCompatibilityFail sexual_compatibility_fail = 40;
     */
    value: NotificationSexualCompatibilityFail;
    case: "sexualCompatibilityFail";
  } | {
    /**
     * @generated from field: gdx.events.v1.RetentionActionResultEvent retention_action_result = 41;
     */
    value: RetentionActionResultEvent;
    case: "retentionActionResult";
  } | {
    /**
     * @generated from field: gdx.gateway.web.notification.v1.NotificationSexualCompatibilityPromo sexual_compatibility_promo = 42;
     */
    value: NotificationSexualCompatibilityPromo;
    case: "sexualCompatibilityPromo";
  } | {
    /**
     * @generated from field: gdx.gateway.web.notification.v1.NotificationAstroCompatibilityPromo astro_compatibility_promo = 43;
     */
    value: NotificationAstroCompatibilityPromo;
    case: "astroCompatibilityPromo";
  } | {
    /**
     * @generated from field: gdx.gateway.web.notification.v1.NotificationPowerLikeDeclined power_like_declined = 44;
     */
    value: NotificationPowerLikeDeclined;
    case: "powerLikeDeclined";
  } | {
    /**
     * @generated from field: gdx.gateway.web.notification.v1.NotificationPowerLikeAccepted power_like_accepted = 45;
     */
    value: NotificationPowerLikeAccepted;
    case: "powerLikeAccepted";
  } | {
    /**
     * @generated from field: gdx.gateway.web.notification.v1.NotificationCreditsFeatureSuccess credits_feature_success = 46;
     */
    value: NotificationCreditsFeatureSuccess;
    case: "creditsFeatureSuccess";
  } | {
    /**
     * @generated from field: gdx.gateway.web.notification.v1.NotificationCreditsFeatureFail credits_feature_fail = 47;
     */
    value: NotificationCreditsFeatureFail;
    case: "creditsFeatureFail";
  } | {
    /**
     * @generated from field: gdx.gateway.web.notification.v1.NotificationSexualCompatibility sexual_compatibility = 48;
     */
    value: NotificationSexualCompatibility;
    case: "sexualCompatibility";
  } | {
    /**
     * @generated from field: gdx.gateway.web.notification.v1.NotificationAstroCompatibility astro_compatibility = 49;
     */
    value: NotificationAstroCompatibility;
    case: "astroCompatibility";
  } | {
    /**
     * @generated from field: gdx.events.v1.RetentionRewardReceivedEvent retention_reward_received_event = 50;
     */
    value: RetentionRewardReceivedEvent;
    case: "retentionRewardReceivedEvent";
  } | {
    /**
     * @generated from field: gdx.gateway.web.notification.v1.NotificationCreditCardAdded credit_card_added = 51;
     */
    value: NotificationCreditCardAdded;
    case: "creditCardAdded";
  } | {
    /**
     * @generated from field: gdx.gateway.web.notification.v1.NotificationCreditCardRemoved credit_card_removed = 52;
     */
    value: NotificationCreditCardRemoved;
    case: "creditCardRemoved";
  } | {
    /**
     * @generated from field: gdx.gateway.web.notification.v1.NotificationFeatureLimit feature_limit = 53;
     */
    value: NotificationFeatureLimit;
    case: "featureLimit";
  } | {
    /**
     * @generated from field: gdx.gateway.web.notification.v1.NotificationRequestPhotoRequested request_photo_requested = 54;
     */
    value: NotificationRequestPhotoRequested;
    case: "requestPhotoRequested";
  } | {
    /**
     * @generated from field: gdx.gateway.web.notification.v1.NotificationNewUndeliveredConversions new_undelivered_conversions = 55;
     */
    value: NotificationNewUndeliveredConversions;
    case: "newUndeliveredConversions";
  } | {
    /**
     * @generated from field: gdx.gateway.web.notification.v1.NotificationPossibilitiesPurchasedSuccessfully possibilities_purchased_successfully = 56;
     */
    value: NotificationPossibilitiesPurchasedSuccessfully;
    case: "possibilitiesPurchasedSuccessfully";
  } | {
    /**
     * @generated from field: gdx.gateway.web.notification.v1.NotificationPossibilitiesUpdated possibilities_updated = 57;
     */
    value: NotificationPossibilitiesUpdated;
    case: "possibilitiesUpdated";
  } | {
    /**
     * @generated from field: gdx.events.v1.ReviewPopUpEvent review_popup_event = 58;
     */
    value: ReviewPopUpEvent;
    case: "reviewPopupEvent";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<Notification>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.notification.v1.Notification";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 5, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 1, name: "match_from_user", kind: "message", T: NotificationMatchFromUser, oneof: "notification" },
    { no: 2, name: "match_from_me", kind: "message", T: NotificationMatchFromMe, oneof: "notification" },
    { no: 3, name: "visit", kind: "message", T: NotificationVisit, oneof: "notification" },
    { no: 4, name: "like", kind: "message", T: NotificationLike, oneof: "notification" },
    { no: 12, name: "dialog_message", kind: "message", T: NotificationDialogMessage, oneof: "notification" },
    { no: 15, name: "likes_count_view_updated", kind: "message", T: NotificationLikesCountViewUpdated, oneof: "notification" },
    { no: 16, name: "unread_messages_count_view_updated", kind: "message", T: NotificationUnreadMessagesCountViewUpdated, oneof: "notification" },
    { no: 17, name: "dialog_message_deleted", kind: "message", T: NotificationDialogMessageDeleted, oneof: "notification" },
    { no: 19, name: "show_promos", kind: "message", T: NotificationShowPromos, oneof: "notification" },
    { no: 20, name: "payment_order_status", kind: "message", T: NotificationPaymentOrderStatusUpdate, oneof: "notification" },
    { no: 21, name: "dialog_message_restricted", kind: "message", T: NotificationDialogMessageRestricted, oneof: "notification" },
    { no: 22, name: "subscription_updated", kind: "message", T: NotificationSubscriptionUpdated, oneof: "notification" },
    { no: 23, name: "suspicious_content_reported", kind: "message", T: NotificationSuspiciousContentReported, oneof: "notification" },
    { no: 24, name: "blocked_by_user", kind: "message", T: NotificationBlockedByUser, oneof: "notification" },
    { no: 25, name: "request_photo", kind: "message", T: NotificationRequestPhoto, oneof: "notification" },
    { no: 26, name: "request_photo_uploaded", kind: "message", T: NotificationRequestPhotoUploaded, oneof: "notification" },
    { no: 27, name: "booster_active", kind: "message", T: NotificationBoosterActive, oneof: "notification" },
    { no: 28, name: "credits_refill_success", kind: "message", T: NotificationCreditsRefillSuccess, oneof: "notification" },
    { no: 29, name: "credits_refill_fail", kind: "message", T: NotificationCreditsRefillFail, oneof: "notification" },
    { no: 30, name: "credits_updated", kind: "message", T: NotificationCreditsUpdated, oneof: "notification" },
    { no: 31, name: "subscription_payment_success", kind: "message", T: NotificationSubscriptionPaymentSuccess, oneof: "notification" },
    { no: 32, name: "subscription_payment_failed", kind: "message", T: NotificationSubscriptionPaymentFailed, oneof: "notification" },
    { no: 33, name: "dialog_message_v2", kind: "message", T: NotificationDialogMessageV2, oneof: "notification" },
    { no: 34, name: "send_power_like_success", kind: "message", T: NotificationSendPowerLikeSuccess, oneof: "notification" },
    { no: 35, name: "send_power_like_fail", kind: "message", T: NotificationSendPowerLikeFail, oneof: "notification" },
    { no: 37, name: "compatibility_success", kind: "message", T: NotificationCompatibilitySuccess, oneof: "notification" },
    { no: 38, name: "compatibility_fail", kind: "message", T: NotificationCompatibilityFail, oneof: "notification" },
    { no: 39, name: "sexual_compatibility_success", kind: "message", T: NotificationSexualCompatibilitySuccess, oneof: "notification" },
    { no: 40, name: "sexual_compatibility_fail", kind: "message", T: NotificationSexualCompatibilityFail, oneof: "notification" },
    { no: 41, name: "retention_action_result", kind: "message", T: RetentionActionResultEvent, oneof: "notification" },
    { no: 42, name: "sexual_compatibility_promo", kind: "message", T: NotificationSexualCompatibilityPromo, oneof: "notification" },
    { no: 43, name: "astro_compatibility_promo", kind: "message", T: NotificationAstroCompatibilityPromo, oneof: "notification" },
    { no: 44, name: "power_like_declined", kind: "message", T: NotificationPowerLikeDeclined, oneof: "notification" },
    { no: 45, name: "power_like_accepted", kind: "message", T: NotificationPowerLikeAccepted, oneof: "notification" },
    { no: 46, name: "credits_feature_success", kind: "message", T: NotificationCreditsFeatureSuccess, oneof: "notification" },
    { no: 47, name: "credits_feature_fail", kind: "message", T: NotificationCreditsFeatureFail, oneof: "notification" },
    { no: 48, name: "sexual_compatibility", kind: "message", T: NotificationSexualCompatibility, oneof: "notification" },
    { no: 49, name: "astro_compatibility", kind: "message", T: NotificationAstroCompatibility, oneof: "notification" },
    { no: 50, name: "retention_reward_received_event", kind: "message", T: RetentionRewardReceivedEvent, oneof: "notification" },
    { no: 51, name: "credit_card_added", kind: "message", T: NotificationCreditCardAdded, oneof: "notification" },
    { no: 52, name: "credit_card_removed", kind: "message", T: NotificationCreditCardRemoved, oneof: "notification" },
    { no: 53, name: "feature_limit", kind: "message", T: NotificationFeatureLimit, oneof: "notification" },
    { no: 54, name: "request_photo_requested", kind: "message", T: NotificationRequestPhotoRequested, oneof: "notification" },
    { no: 55, name: "new_undelivered_conversions", kind: "message", T: NotificationNewUndeliveredConversions, oneof: "notification" },
    { no: 56, name: "possibilities_purchased_successfully", kind: "message", T: NotificationPossibilitiesPurchasedSuccessfully, oneof: "notification" },
    { no: 57, name: "possibilities_updated", kind: "message", T: NotificationPossibilitiesUpdated, oneof: "notification" },
    { no: 58, name: "review_popup_event", kind: "message", T: ReviewPopUpEvent, oneof: "notification" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Notification {
    return new Notification().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Notification {
    return new Notification().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Notification {
    return new Notification().fromJsonString(jsonString, options);
  }

  static equals(a: Notification | PlainMessage<Notification> | undefined, b: Notification | PlainMessage<Notification> | undefined): boolean {
    return proto3.util.equals(Notification, a, b);
  }
}

/**
 * We get this notification when power like is accepted.
 *
 * @generated from message gdx.gateway.web.notification.v1.NotificationPowerLikeAccepted
 */
export class NotificationPowerLikeAccepted extends Message<NotificationPowerLikeAccepted> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  constructor(data?: PartialMessage<NotificationPowerLikeAccepted>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.notification.v1.NotificationPowerLikeAccepted";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationPowerLikeAccepted {
    return new NotificationPowerLikeAccepted().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationPowerLikeAccepted {
    return new NotificationPowerLikeAccepted().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationPowerLikeAccepted {
    return new NotificationPowerLikeAccepted().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationPowerLikeAccepted | PlainMessage<NotificationPowerLikeAccepted> | undefined, b: NotificationPowerLikeAccepted | PlainMessage<NotificationPowerLikeAccepted> | undefined): boolean {
    return proto3.util.equals(NotificationPowerLikeAccepted, a, b);
  }
}

/**
 * We get this notification when power like is declined.
 *
 * @generated from message gdx.gateway.web.notification.v1.NotificationPowerLikeDeclined
 */
export class NotificationPowerLikeDeclined extends Message<NotificationPowerLikeDeclined> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  constructor(data?: PartialMessage<NotificationPowerLikeDeclined>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.notification.v1.NotificationPowerLikeDeclined";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationPowerLikeDeclined {
    return new NotificationPowerLikeDeclined().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationPowerLikeDeclined {
    return new NotificationPowerLikeDeclined().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationPowerLikeDeclined {
    return new NotificationPowerLikeDeclined().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationPowerLikeDeclined | PlainMessage<NotificationPowerLikeDeclined> | undefined, b: NotificationPowerLikeDeclined | PlainMessage<NotificationPowerLikeDeclined> | undefined): boolean {
    return proto3.util.equals(NotificationPowerLikeDeclined, a, b);
  }
}

/**
 * We get this notification when sexual compatibility activation success.
 *
 * @generated from message gdx.gateway.web.notification.v1.NotificationSexualCompatibilitySuccess
 */
export class NotificationSexualCompatibilitySuccess extends Message<NotificationSexualCompatibilitySuccess> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  constructor(data?: PartialMessage<NotificationSexualCompatibilitySuccess>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.notification.v1.NotificationSexualCompatibilitySuccess";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationSexualCompatibilitySuccess {
    return new NotificationSexualCompatibilitySuccess().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationSexualCompatibilitySuccess {
    return new NotificationSexualCompatibilitySuccess().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationSexualCompatibilitySuccess {
    return new NotificationSexualCompatibilitySuccess().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationSexualCompatibilitySuccess | PlainMessage<NotificationSexualCompatibilitySuccess> | undefined, b: NotificationSexualCompatibilitySuccess | PlainMessage<NotificationSexualCompatibilitySuccess> | undefined): boolean {
    return proto3.util.equals(NotificationSexualCompatibilitySuccess, a, b);
  }
}

/**
 * We get this notification when sexual compatibility activation fails.
 *
 * @generated from message gdx.gateway.web.notification.v1.NotificationSexualCompatibilityFail
 */
export class NotificationSexualCompatibilityFail extends Message<NotificationSexualCompatibilityFail> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  constructor(data?: PartialMessage<NotificationSexualCompatibilityFail>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.notification.v1.NotificationSexualCompatibilityFail";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationSexualCompatibilityFail {
    return new NotificationSexualCompatibilityFail().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationSexualCompatibilityFail {
    return new NotificationSexualCompatibilityFail().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationSexualCompatibilityFail {
    return new NotificationSexualCompatibilityFail().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationSexualCompatibilityFail | PlainMessage<NotificationSexualCompatibilityFail> | undefined, b: NotificationSexualCompatibilityFail | PlainMessage<NotificationSexualCompatibilityFail> | undefined): boolean {
    return proto3.util.equals(NotificationSexualCompatibilityFail, a, b);
  }
}

/**
 * We get this notification when user successfully activates astrology compatibility.
 *
 * @generated from message gdx.gateway.web.notification.v1.NotificationCompatibilitySuccess
 */
export class NotificationCompatibilitySuccess extends Message<NotificationCompatibilitySuccess> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  constructor(data?: PartialMessage<NotificationCompatibilitySuccess>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.notification.v1.NotificationCompatibilitySuccess";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationCompatibilitySuccess {
    return new NotificationCompatibilitySuccess().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationCompatibilitySuccess {
    return new NotificationCompatibilitySuccess().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationCompatibilitySuccess {
    return new NotificationCompatibilitySuccess().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationCompatibilitySuccess | PlainMessage<NotificationCompatibilitySuccess> | undefined, b: NotificationCompatibilitySuccess | PlainMessage<NotificationCompatibilitySuccess> | undefined): boolean {
    return proto3.util.equals(NotificationCompatibilitySuccess, a, b);
  }
}

/**
 * We get this notification when user successfully adds new credit card.
 *
 * @generated from message gdx.gateway.web.notification.v1.NotificationCreditCardAdded
 */
export class NotificationCreditCardAdded extends Message<NotificationCreditCardAdded> {
  constructor(data?: PartialMessage<NotificationCreditCardAdded>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.notification.v1.NotificationCreditCardAdded";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationCreditCardAdded {
    return new NotificationCreditCardAdded().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationCreditCardAdded {
    return new NotificationCreditCardAdded().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationCreditCardAdded {
    return new NotificationCreditCardAdded().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationCreditCardAdded | PlainMessage<NotificationCreditCardAdded> | undefined, b: NotificationCreditCardAdded | PlainMessage<NotificationCreditCardAdded> | undefined): boolean {
    return proto3.util.equals(NotificationCreditCardAdded, a, b);
  }
}

/**
 * We get this notification when user successfully removes new credit card.
 *
 * @generated from message gdx.gateway.web.notification.v1.NotificationCreditCardRemoved
 */
export class NotificationCreditCardRemoved extends Message<NotificationCreditCardRemoved> {
  constructor(data?: PartialMessage<NotificationCreditCardRemoved>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.notification.v1.NotificationCreditCardRemoved";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationCreditCardRemoved {
    return new NotificationCreditCardRemoved().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationCreditCardRemoved {
    return new NotificationCreditCardRemoved().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationCreditCardRemoved {
    return new NotificationCreditCardRemoved().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationCreditCardRemoved | PlainMessage<NotificationCreditCardRemoved> | undefined, b: NotificationCreditCardRemoved | PlainMessage<NotificationCreditCardRemoved> | undefined): boolean {
    return proto3.util.equals(NotificationCreditCardRemoved, a, b);
  }
}

/**
 * We get this notification when astrology compatibility activation fails.
 *
 * @generated from message gdx.gateway.web.notification.v1.NotificationCompatibilityFail
 */
export class NotificationCompatibilityFail extends Message<NotificationCompatibilityFail> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  constructor(data?: PartialMessage<NotificationCompatibilityFail>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.notification.v1.NotificationCompatibilityFail";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationCompatibilityFail {
    return new NotificationCompatibilityFail().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationCompatibilityFail {
    return new NotificationCompatibilityFail().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationCompatibilityFail {
    return new NotificationCompatibilityFail().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationCompatibilityFail | PlainMessage<NotificationCompatibilityFail> | undefined, b: NotificationCompatibilityFail | PlainMessage<NotificationCompatibilityFail> | undefined): boolean {
    return proto3.util.equals(NotificationCompatibilityFail, a, b);
  }
}

/**
 * We get this notification when user blocked us.
 *
 * @generated from message gdx.gateway.web.notification.v1.NotificationBlockedByUser
 */
export class NotificationBlockedByUser extends Message<NotificationBlockedByUser> {
  /**
   * id of a user who blocked you.
   *
   * @generated from field: string user_id = 1;
   */
  userId = "";

  constructor(data?: PartialMessage<NotificationBlockedByUser>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.notification.v1.NotificationBlockedByUser";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationBlockedByUser {
    return new NotificationBlockedByUser().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationBlockedByUser {
    return new NotificationBlockedByUser().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationBlockedByUser {
    return new NotificationBlockedByUser().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationBlockedByUser | PlainMessage<NotificationBlockedByUser> | undefined, b: NotificationBlockedByUser | PlainMessage<NotificationBlockedByUser> | undefined): boolean {
    return proto3.util.equals(NotificationBlockedByUser, a, b);
  }
}

/**
 * We get this notification when user liked us, but we had liked him before.
 *
 * @generated from message gdx.gateway.web.notification.v1.NotificationMatchFromUser
 */
export class NotificationMatchFromUser extends Message<NotificationMatchFromUser> {
  /**
   * @generated from field: string dialog_id = 1;
   */
  dialogId = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: uint32 age = 3;
   */
  age = 0;

  /**
   * @generated from field: bool is_online = 4;
   */
  isOnline = false;

  /**
   * @generated from field: gdx.gateway.web.profile.v1.ProfilePhoto avatar = 5;
   */
  avatar?: ProfilePhoto;

  /**
   * User's id we matched with.
   *
   * @generated from field: string user_id = 6;
   */
  userId = "";

  /**
   * @generated from field: bool is_power_like = 7;
   */
  isPowerLike = false;

  constructor(data?: PartialMessage<NotificationMatchFromUser>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.notification.v1.NotificationMatchFromUser";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "dialog_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "age", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 4, name: "is_online", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "avatar", kind: "message", T: ProfilePhoto },
    { no: 6, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "is_power_like", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationMatchFromUser {
    return new NotificationMatchFromUser().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationMatchFromUser {
    return new NotificationMatchFromUser().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationMatchFromUser {
    return new NotificationMatchFromUser().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationMatchFromUser | PlainMessage<NotificationMatchFromUser> | undefined, b: NotificationMatchFromUser | PlainMessage<NotificationMatchFromUser> | undefined): boolean {
    return proto3.util.equals(NotificationMatchFromUser, a, b);
  }
}

/**
 * We get this notification when we liked user, but user had liked us before.
 *
 * @generated from message gdx.gateway.web.notification.v1.NotificationMatchFromMe
 */
export class NotificationMatchFromMe extends Message<NotificationMatchFromMe> {
  /**
   * @generated from field: string dialog_id = 1;
   */
  dialogId = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: uint32 age = 3;
   */
  age = 0;

  /**
   * @generated from field: bool is_online = 4;
   */
  isOnline = false;

  /**
   * @generated from field: gdx.gateway.web.profile.v1.ProfilePhoto avatar = 7;
   */
  avatar?: ProfilePhoto;

  /**
   * @generated from field: gdx.gateway.web.profile.v1.ProfilePhoto my_avatar = 8;
   */
  myAvatar?: ProfilePhoto;

  /**
   * User's id we matched with.
   *
   * @generated from field: string user_id = 6;
   */
  userId = "";

  /**
   * @generated from field: bool is_power_like = 9;
   */
  isPowerLike = false;

  constructor(data?: PartialMessage<NotificationMatchFromMe>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.notification.v1.NotificationMatchFromMe";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "dialog_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "age", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 4, name: "is_online", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "avatar", kind: "message", T: ProfilePhoto },
    { no: 8, name: "my_avatar", kind: "message", T: ProfilePhoto },
    { no: 6, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "is_power_like", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationMatchFromMe {
    return new NotificationMatchFromMe().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationMatchFromMe {
    return new NotificationMatchFromMe().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationMatchFromMe {
    return new NotificationMatchFromMe().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationMatchFromMe | PlainMessage<NotificationMatchFromMe> | undefined, b: NotificationMatchFromMe | PlainMessage<NotificationMatchFromMe> | undefined): boolean {
    return proto3.util.equals(NotificationMatchFromMe, a, b);
  }
}

/**
 * We get this notification when someone's liked us, but we hadn't liked this user before.
 *
 * @generated from message gdx.gateway.web.notification.v1.NotificationLike
 */
export class NotificationLike extends Message<NotificationLike> {
  /**
   * id of a user who liked you, could be '0' if you don't have a premium.
   *
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: gdx.gateway.web.profile.v1.ProfileGender gender = 2;
   */
  gender = ProfileGender.INVALID;

  /**
   * @generated from field: gdx.gateway.web.profile.v1.ProfilePhoto avatar = 3;
   */
  avatar?: ProfilePhoto;

  /**
   * @generated from field: string name = 4;
   */
  name = "";

  /**
   * @generated from field: uint32 age = 5;
   */
  age = 0;

  constructor(data?: PartialMessage<NotificationLike>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.notification.v1.NotificationLike";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "gender", kind: "enum", T: proto3.getEnumType(ProfileGender) },
    { no: 3, name: "avatar", kind: "message", T: ProfilePhoto },
    { no: 4, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "age", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationLike {
    return new NotificationLike().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationLike {
    return new NotificationLike().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationLike {
    return new NotificationLike().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationLike | PlainMessage<NotificationLike> | undefined, b: NotificationLike | PlainMessage<NotificationLike> | undefined): boolean {
    return proto3.util.equals(NotificationLike, a, b);
  }
}

/**
 * We get this notification when someone's visited our profile.
 *
 * @generated from message gdx.gateway.web.notification.v1.NotificationVisit
 */
export class NotificationVisit extends Message<NotificationVisit> {
  /**
   * visitor user id is required to go to user's profile if we'll click on notification.
   *
   * @generated from field: string visitor_user_id = 1;
   */
  visitorUserId = "";

  /**
   * @generated from field: gdx.gateway.web.profile.v1.ProfilePhoto avatar = 2;
   */
  avatar?: ProfilePhoto;

  /**
   * @generated from field: string visitor_name = 3;
   */
  visitorName = "";

  /**
   * @generated from field: uint32 visitor_age = 4;
   */
  visitorAge = 0;

  constructor(data?: PartialMessage<NotificationVisit>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.notification.v1.NotificationVisit";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "visitor_user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "avatar", kind: "message", T: ProfilePhoto },
    { no: 3, name: "visitor_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "visitor_age", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationVisit {
    return new NotificationVisit().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationVisit {
    return new NotificationVisit().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationVisit {
    return new NotificationVisit().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationVisit | PlainMessage<NotificationVisit> | undefined, b: NotificationVisit | PlainMessage<NotificationVisit> | undefined): boolean {
    return proto3.util.equals(NotificationVisit, a, b);
  }
}

/**
 * This message will be sent via websocket.
 *
 * @generated from message gdx.gateway.web.notification.v1.NotificationDialogMessage
 */
export class NotificationDialogMessage extends Message<NotificationDialogMessage> {
  /**
   * @generated from field: string dialog_id = 1;
   */
  dialogId = "";

  /**
   * @generated from field: gdx.gateway.web.chat.v1.DialogMessage message = 2;
   */
  message?: DialogMessage;

  constructor(data?: PartialMessage<NotificationDialogMessage>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.notification.v1.NotificationDialogMessage";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "dialog_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "message", kind: "message", T: DialogMessage },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationDialogMessage {
    return new NotificationDialogMessage().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationDialogMessage {
    return new NotificationDialogMessage().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationDialogMessage {
    return new NotificationDialogMessage().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationDialogMessage | PlainMessage<NotificationDialogMessage> | undefined, b: NotificationDialogMessage | PlainMessage<NotificationDialogMessage> | undefined): boolean {
    return proto3.util.equals(NotificationDialogMessage, a, b);
  }
}

/**
 * This message will be sent via websocket.
 *
 * @generated from message gdx.gateway.web.notification.v1.NotificationDialogMessageV2
 */
export class NotificationDialogMessageV2 extends Message<NotificationDialogMessageV2> {
  /**
   * @generated from field: string dialog_id = 1;
   */
  dialogId = "";

  /**
   * @generated from field: gdx.gateway.web.notification.v1.NotificationDialogMessageV2.DialogMessage message = 2;
   */
  message?: NotificationDialogMessageV2_DialogMessage;

  constructor(data?: PartialMessage<NotificationDialogMessageV2>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.notification.v1.NotificationDialogMessageV2";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "dialog_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "message", kind: "message", T: NotificationDialogMessageV2_DialogMessage },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationDialogMessageV2 {
    return new NotificationDialogMessageV2().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationDialogMessageV2 {
    return new NotificationDialogMessageV2().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationDialogMessageV2 {
    return new NotificationDialogMessageV2().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationDialogMessageV2 | PlainMessage<NotificationDialogMessageV2> | undefined, b: NotificationDialogMessageV2 | PlainMessage<NotificationDialogMessageV2> | undefined): boolean {
    return proto3.util.equals(NotificationDialogMessageV2, a, b);
  }
}

/**
 * Dialog message, capt.
 *
 * @generated from message gdx.gateway.web.notification.v1.NotificationDialogMessageV2.DialogMessage
 */
export class NotificationDialogMessageV2_DialogMessage extends Message<NotificationDialogMessageV2_DialogMessage> {
  /**
   * @generated from field: string message_id = 1;
   */
  messageId = "";

  /**
   * @generated from field: bool is_new = 2;
   */
  isNew = false;

  /**
   * @generated from field: gdx.gateway.web.notification.v1.NotificationDialogMessageV2.DialogMessage.Content content = 3;
   */
  content?: NotificationDialogMessageV2_DialogMessage_Content;

  /**
   * @generated from field: string sender_id = 4;
   */
  senderId = "";

  /**
   * @generated from field: bool is_system = 5;
   */
  isSystem = false;

  /**
   * @generated from field: bool is_suspicious_content = 6;
   */
  isSuspiciousContent = false;

  /**
   * @generated from field: google.protobuf.Duration created_duration = 10;
   */
  createdDuration?: Duration;

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 11;
   */
  createdTime?: Timestamp;

  /**
   * @generated from field: bool is_locked = 12;
   */
  isLocked = false;

  constructor(data?: PartialMessage<NotificationDialogMessageV2_DialogMessage>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.notification.v1.NotificationDialogMessageV2.DialogMessage";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "message_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "is_new", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "content", kind: "message", T: NotificationDialogMessageV2_DialogMessage_Content },
    { no: 4, name: "sender_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "is_system", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "is_suspicious_content", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "created_duration", kind: "message", T: Duration },
    { no: 11, name: "created_time", kind: "message", T: Timestamp },
    { no: 12, name: "is_locked", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationDialogMessageV2_DialogMessage {
    return new NotificationDialogMessageV2_DialogMessage().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationDialogMessageV2_DialogMessage {
    return new NotificationDialogMessageV2_DialogMessage().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationDialogMessageV2_DialogMessage {
    return new NotificationDialogMessageV2_DialogMessage().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationDialogMessageV2_DialogMessage | PlainMessage<NotificationDialogMessageV2_DialogMessage> | undefined, b: NotificationDialogMessageV2_DialogMessage | PlainMessage<NotificationDialogMessageV2_DialogMessage> | undefined): boolean {
    return proto3.util.equals(NotificationDialogMessageV2_DialogMessage, a, b);
  }
}

/**
 * Content.
 *
 * @generated from message gdx.gateway.web.notification.v1.NotificationDialogMessageV2.DialogMessage.Content
 */
export class NotificationDialogMessageV2_DialogMessage_Content extends Message<NotificationDialogMessageV2_DialogMessage_Content> {
  /**
   * @generated from oneof gdx.gateway.web.notification.v1.NotificationDialogMessageV2.DialogMessage.Content.content
   */
  content: {
    /**
     * @generated from field: string text = 2;
     */
    value: string;
    case: "text";
  } | {
    /**
     * @generated from field: gdx.gateway.web.notification.v1.NotificationDialogMessageV2.DialogMessage.Content.Image image = 3;
     */
    value: NotificationDialogMessageV2_DialogMessage_Content_Image;
    case: "image";
  } | {
    /**
     * @generated from field: gdx.gateway.web.notification.v1.NotificationDialogMessageV2.DialogMessage.Content.Gift gift = 4;
     */
    value: NotificationDialogMessageV2_DialogMessage_Content_Gift;
    case: "gift";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<NotificationDialogMessageV2_DialogMessage_Content>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.notification.v1.NotificationDialogMessageV2.DialogMessage.Content";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 2, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "content" },
    { no: 3, name: "image", kind: "message", T: NotificationDialogMessageV2_DialogMessage_Content_Image, oneof: "content" },
    { no: 4, name: "gift", kind: "message", T: NotificationDialogMessageV2_DialogMessage_Content_Gift, oneof: "content" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationDialogMessageV2_DialogMessage_Content {
    return new NotificationDialogMessageV2_DialogMessage_Content().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationDialogMessageV2_DialogMessage_Content {
    return new NotificationDialogMessageV2_DialogMessage_Content().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationDialogMessageV2_DialogMessage_Content {
    return new NotificationDialogMessageV2_DialogMessage_Content().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationDialogMessageV2_DialogMessage_Content | PlainMessage<NotificationDialogMessageV2_DialogMessage_Content> | undefined, b: NotificationDialogMessageV2_DialogMessage_Content | PlainMessage<NotificationDialogMessageV2_DialogMessage_Content> | undefined): boolean {
    return proto3.util.equals(NotificationDialogMessageV2_DialogMessage_Content, a, b);
  }
}

/**
 * Image.
 *
 * @generated from message gdx.gateway.web.notification.v1.NotificationDialogMessageV2.DialogMessage.Content.Image
 */
export class NotificationDialogMessageV2_DialogMessage_Content_Image extends Message<NotificationDialogMessageV2_DialogMessage_Content_Image> {
  /**
   * @generated from field: string photo_id = 1;
   */
  photoId = "";

  constructor(data?: PartialMessage<NotificationDialogMessageV2_DialogMessage_Content_Image>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.notification.v1.NotificationDialogMessageV2.DialogMessage.Content.Image";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "photo_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationDialogMessageV2_DialogMessage_Content_Image {
    return new NotificationDialogMessageV2_DialogMessage_Content_Image().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationDialogMessageV2_DialogMessage_Content_Image {
    return new NotificationDialogMessageV2_DialogMessage_Content_Image().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationDialogMessageV2_DialogMessage_Content_Image {
    return new NotificationDialogMessageV2_DialogMessage_Content_Image().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationDialogMessageV2_DialogMessage_Content_Image | PlainMessage<NotificationDialogMessageV2_DialogMessage_Content_Image> | undefined, b: NotificationDialogMessageV2_DialogMessage_Content_Image | PlainMessage<NotificationDialogMessageV2_DialogMessage_Content_Image> | undefined): boolean {
    return proto3.util.equals(NotificationDialogMessageV2_DialogMessage_Content_Image, a, b);
  }
}

/**
 * Gift.
 *
 * @generated from message gdx.gateway.web.notification.v1.NotificationDialogMessageV2.DialogMessage.Content.Gift
 */
export class NotificationDialogMessageV2_DialogMessage_Content_Gift extends Message<NotificationDialogMessageV2_DialogMessage_Content_Gift> {
  /**
   * @generated from field: string gift_id = 1;
   */
  giftId = "";

  /**
   * @generated from field: string photo_id = 2;
   */
  photoId = "";

  /**
   * @generated from field: string text = 3;
   */
  text = "";

  constructor(data?: PartialMessage<NotificationDialogMessageV2_DialogMessage_Content_Gift>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.notification.v1.NotificationDialogMessageV2.DialogMessage.Content.Gift";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "gift_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "photo_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationDialogMessageV2_DialogMessage_Content_Gift {
    return new NotificationDialogMessageV2_DialogMessage_Content_Gift().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationDialogMessageV2_DialogMessage_Content_Gift {
    return new NotificationDialogMessageV2_DialogMessage_Content_Gift().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationDialogMessageV2_DialogMessage_Content_Gift {
    return new NotificationDialogMessageV2_DialogMessage_Content_Gift().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationDialogMessageV2_DialogMessage_Content_Gift | PlainMessage<NotificationDialogMessageV2_DialogMessage_Content_Gift> | undefined, b: NotificationDialogMessageV2_DialogMessage_Content_Gift | PlainMessage<NotificationDialogMessageV2_DialogMessage_Content_Gift> | undefined): boolean {
    return proto3.util.equals(NotificationDialogMessageV2_DialogMessage_Content_Gift, a, b);
  }
}

/**
 * Occurs when message was restricted.
 *
 * @generated from message gdx.gateway.web.notification.v1.NotificationDialogMessageRestricted
 */
export class NotificationDialogMessageRestricted extends Message<NotificationDialogMessageRestricted> {
  /**
   * @generated from field: string dialog_id = 1;
   */
  dialogId = "";

  /**
   * @generated from field: string message_id = 2;
   */
  messageId = "";

  /**
   * @generated from field: gdx.gateway.web.chat.v1.RestrictionReason reason = 3;
   */
  reason = RestrictionReason.INVALID;

  constructor(data?: PartialMessage<NotificationDialogMessageRestricted>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.notification.v1.NotificationDialogMessageRestricted";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "dialog_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "message_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "reason", kind: "enum", T: proto3.getEnumType(RestrictionReason) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationDialogMessageRestricted {
    return new NotificationDialogMessageRestricted().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationDialogMessageRestricted {
    return new NotificationDialogMessageRestricted().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationDialogMessageRestricted {
    return new NotificationDialogMessageRestricted().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationDialogMessageRestricted | PlainMessage<NotificationDialogMessageRestricted> | undefined, b: NotificationDialogMessageRestricted | PlainMessage<NotificationDialogMessageRestricted> | undefined): boolean {
    return proto3.util.equals(NotificationDialogMessageRestricted, a, b);
  }
}

/**
 * Occurs on any likes count update.
 *
 * @generated from message gdx.gateway.web.notification.v1.NotificationLikesCountViewUpdated
 */
export class NotificationLikesCountViewUpdated extends Message<NotificationLikesCountViewUpdated> {
  /**
   * @generated from field: uint32 likes_count = 1;
   */
  likesCount = 0;

  constructor(data?: PartialMessage<NotificationLikesCountViewUpdated>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.notification.v1.NotificationLikesCountViewUpdated";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "likes_count", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationLikesCountViewUpdated {
    return new NotificationLikesCountViewUpdated().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationLikesCountViewUpdated {
    return new NotificationLikesCountViewUpdated().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationLikesCountViewUpdated {
    return new NotificationLikesCountViewUpdated().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationLikesCountViewUpdated | PlainMessage<NotificationLikesCountViewUpdated> | undefined, b: NotificationLikesCountViewUpdated | PlainMessage<NotificationLikesCountViewUpdated> | undefined): boolean {
    return proto3.util.equals(NotificationLikesCountViewUpdated, a, b);
  }
}

/**
 * Occurs on any unread messages count update.
 *
 * @generated from message gdx.gateway.web.notification.v1.NotificationUnreadMessagesCountViewUpdated
 */
export class NotificationUnreadMessagesCountViewUpdated extends Message<NotificationUnreadMessagesCountViewUpdated> {
  /**
   * @generated from field: uint32 unread_messages_count = 1;
   */
  unreadMessagesCount = 0;

  constructor(data?: PartialMessage<NotificationUnreadMessagesCountViewUpdated>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.notification.v1.NotificationUnreadMessagesCountViewUpdated";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "unread_messages_count", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationUnreadMessagesCountViewUpdated {
    return new NotificationUnreadMessagesCountViewUpdated().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationUnreadMessagesCountViewUpdated {
    return new NotificationUnreadMessagesCountViewUpdated().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationUnreadMessagesCountViewUpdated {
    return new NotificationUnreadMessagesCountViewUpdated().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationUnreadMessagesCountViewUpdated | PlainMessage<NotificationUnreadMessagesCountViewUpdated> | undefined, b: NotificationUnreadMessagesCountViewUpdated | PlainMessage<NotificationUnreadMessagesCountViewUpdated> | undefined): boolean {
    return proto3.util.equals(NotificationUnreadMessagesCountViewUpdated, a, b);
  }
}

/**
 * Occurs on dialog message delete.
 *
 * @generated from message gdx.gateway.web.notification.v1.NotificationDialogMessageDeleted
 */
export class NotificationDialogMessageDeleted extends Message<NotificationDialogMessageDeleted> {
  /**
   * @generated from field: string dialog_id = 1;
   */
  dialogId = "";

  /**
   * @generated from field: string message_id = 2;
   */
  messageId = "";

  constructor(data?: PartialMessage<NotificationDialogMessageDeleted>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.notification.v1.NotificationDialogMessageDeleted";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "dialog_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "message_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationDialogMessageDeleted {
    return new NotificationDialogMessageDeleted().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationDialogMessageDeleted {
    return new NotificationDialogMessageDeleted().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationDialogMessageDeleted {
    return new NotificationDialogMessageDeleted().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationDialogMessageDeleted | PlainMessage<NotificationDialogMessageDeleted> | undefined, b: NotificationDialogMessageDeleted | PlainMessage<NotificationDialogMessageDeleted> | undefined): boolean {
    return proto3.util.equals(NotificationDialogMessageDeleted, a, b);
  }
}

/**
 * Occurs on dialog message suspicious content reported.
 *
 * @generated from message gdx.gateway.web.notification.v1.NotificationSuspiciousContentReported
 */
export class NotificationSuspiciousContentReported extends Message<NotificationSuspiciousContentReported> {
  /**
   * @generated from field: string message_id = 1;
   */
  messageId = "";

  /**
   * @generated from field: string dialog_id = 2;
   */
  dialogId = "";

  constructor(data?: PartialMessage<NotificationSuspiciousContentReported>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.notification.v1.NotificationSuspiciousContentReported";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "message_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "dialog_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationSuspiciousContentReported {
    return new NotificationSuspiciousContentReported().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationSuspiciousContentReported {
    return new NotificationSuspiciousContentReported().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationSuspiciousContentReported {
    return new NotificationSuspiciousContentReported().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationSuspiciousContentReported | PlainMessage<NotificationSuspiciousContentReported> | undefined, b: NotificationSuspiciousContentReported | PlainMessage<NotificationSuspiciousContentReported> | undefined): boolean {
    return proto3.util.equals(NotificationSuspiciousContentReported, a, b);
  }
}

/**
 * Occurs when front-end client needs to show promos to user.
 *
 * @generated from message gdx.gateway.web.notification.v1.NotificationShowPromos
 */
export class NotificationShowPromos extends Message<NotificationShowPromos> {
  constructor(data?: PartialMessage<NotificationShowPromos>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.notification.v1.NotificationShowPromos";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationShowPromos {
    return new NotificationShowPromos().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationShowPromos {
    return new NotificationShowPromos().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationShowPromos {
    return new NotificationShowPromos().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationShowPromos | PlainMessage<NotificationShowPromos> | undefined, b: NotificationShowPromos | PlainMessage<NotificationShowPromos> | undefined): boolean {
    return proto3.util.equals(NotificationShowPromos, a, b);
  }
}

/**
 * Occurs on payment order status updates.
 *
 * @generated from message gdx.gateway.web.notification.v1.NotificationPaymentOrderStatusUpdate
 */
export class NotificationPaymentOrderStatusUpdate extends Message<NotificationPaymentOrderStatusUpdate> {
  /**
   * @generated from field: string order_id = 1;
   */
  orderId = "";

  /**
   * @generated from field: gdx.gateway.web.payment.v2.PaymentOrderStatusDetails status_details = 2;
   */
  statusDetails?: PaymentOrderStatusDetails;

  /**
   * @generated from field: gdx.gateway.web.payment.v2.OrderStatus prev_status = 3;
   */
  prevStatus = OrderStatus.ORDER_STATUS_INVALID;

  /**
   * @generated from field: gdx.gateway.web.payment.v2.PaymentGateway gateway = 4;
   */
  gateway = PaymentGateway.INVALID;

  constructor(data?: PartialMessage<NotificationPaymentOrderStatusUpdate>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.notification.v1.NotificationPaymentOrderStatusUpdate";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status_details", kind: "message", T: PaymentOrderStatusDetails },
    { no: 3, name: "prev_status", kind: "enum", T: proto3.getEnumType(OrderStatus) },
    { no: 4, name: "gateway", kind: "enum", T: proto3.getEnumType(PaymentGateway) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationPaymentOrderStatusUpdate {
    return new NotificationPaymentOrderStatusUpdate().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationPaymentOrderStatusUpdate {
    return new NotificationPaymentOrderStatusUpdate().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationPaymentOrderStatusUpdate {
    return new NotificationPaymentOrderStatusUpdate().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationPaymentOrderStatusUpdate | PlainMessage<NotificationPaymentOrderStatusUpdate> | undefined, b: NotificationPaymentOrderStatusUpdate | PlainMessage<NotificationPaymentOrderStatusUpdate> | undefined): boolean {
    return proto3.util.equals(NotificationPaymentOrderStatusUpdate, a, b);
  }
}

/**
 * Occurs on subscription update.
 *
 * @generated from message gdx.gateway.web.notification.v1.NotificationSubscriptionUpdated
 */
export class NotificationSubscriptionUpdated extends Message<NotificationSubscriptionUpdated> {
  /**
   * @generated from field: gdx.gateway.web.payment.v2.Subscription subscription = 1;
   */
  subscription?: Subscription;

  constructor(data?: PartialMessage<NotificationSubscriptionUpdated>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.notification.v1.NotificationSubscriptionUpdated";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "subscription", kind: "message", T: Subscription },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationSubscriptionUpdated {
    return new NotificationSubscriptionUpdated().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationSubscriptionUpdated {
    return new NotificationSubscriptionUpdated().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationSubscriptionUpdated {
    return new NotificationSubscriptionUpdated().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationSubscriptionUpdated | PlainMessage<NotificationSubscriptionUpdated> | undefined, b: NotificationSubscriptionUpdated | PlainMessage<NotificationSubscriptionUpdated> | undefined): boolean {
    return proto3.util.equals(NotificationSubscriptionUpdated, a, b);
  }
}

/**
 * We get this notification when someone's requested our profile photo.
 *
 * @generated from message gdx.gateway.web.notification.v1.NotificationRequestPhoto
 */
export class NotificationRequestPhoto extends Message<NotificationRequestPhoto> {
  /**
   * visitor user id is required to go to user's profile if we'll click on notification.
   *
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: gdx.gateway.web.profile.v1.ProfilePhoto avatar = 2;
   */
  avatar?: ProfilePhoto;

  /**
   * @generated from field: string name = 3;
   */
  name = "";

  /**
   * @generated from field: uint32 age = 4;
   */
  age = 0;

  constructor(data?: PartialMessage<NotificationRequestPhoto>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.notification.v1.NotificationRequestPhoto";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "avatar", kind: "message", T: ProfilePhoto },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "age", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationRequestPhoto {
    return new NotificationRequestPhoto().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationRequestPhoto {
    return new NotificationRequestPhoto().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationRequestPhoto {
    return new NotificationRequestPhoto().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationRequestPhoto | PlainMessage<NotificationRequestPhoto> | undefined, b: NotificationRequestPhoto | PlainMessage<NotificationRequestPhoto> | undefined): boolean {
    return proto3.util.equals(NotificationRequestPhoto, a, b);
  }
}

/**
 * Occurs for photo request initiator when request is sent successfully.
 *
 * @generated from message gdx.gateway.web.notification.v1.NotificationRequestPhotoRequested
 */
export class NotificationRequestPhotoRequested extends Message<NotificationRequestPhotoRequested> {
  /**
   * @generated from field: string subject_id = 1;
   */
  subjectId = "";

  constructor(data?: PartialMessage<NotificationRequestPhotoRequested>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.notification.v1.NotificationRequestPhotoRequested";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "subject_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationRequestPhotoRequested {
    return new NotificationRequestPhotoRequested().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationRequestPhotoRequested {
    return new NotificationRequestPhotoRequested().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationRequestPhotoRequested {
    return new NotificationRequestPhotoRequested().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationRequestPhotoRequested | PlainMessage<NotificationRequestPhotoRequested> | undefined, b: NotificationRequestPhotoRequested | PlainMessage<NotificationRequestPhotoRequested> | undefined): boolean {
    return proto3.util.equals(NotificationRequestPhotoRequested, a, b);
  }
}

/**
 * We get this notification when someone's uploaded profile photo that we requested earlier.
 *
 * @generated from message gdx.gateway.web.notification.v1.NotificationRequestPhotoUploaded
 */
export class NotificationRequestPhotoUploaded extends Message<NotificationRequestPhotoUploaded> {
  /**
   * visitor user id is required to go to user's profile if we'll click on notification.
   *
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: gdx.gateway.web.profile.v1.ProfilePhoto avatar = 2;
   */
  avatar?: ProfilePhoto;

  /**
   * @generated from field: string name = 3;
   */
  name = "";

  /**
   * @generated from field: uint32 age = 4;
   */
  age = 0;

  constructor(data?: PartialMessage<NotificationRequestPhotoUploaded>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.notification.v1.NotificationRequestPhotoUploaded";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "avatar", kind: "message", T: ProfilePhoto },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "age", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationRequestPhotoUploaded {
    return new NotificationRequestPhotoUploaded().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationRequestPhotoUploaded {
    return new NotificationRequestPhotoUploaded().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationRequestPhotoUploaded {
    return new NotificationRequestPhotoUploaded().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationRequestPhotoUploaded | PlainMessage<NotificationRequestPhotoUploaded> | undefined, b: NotificationRequestPhotoUploaded | PlainMessage<NotificationRequestPhotoUploaded> | undefined): boolean {
    return proto3.util.equals(NotificationRequestPhotoUploaded, a, b);
  }
}

/**
 * Notify booster active.
 *
 * @generated from message gdx.gateway.web.notification.v1.NotificationBoosterActive
 */
export class NotificationBoosterActive extends Message<NotificationBoosterActive> {
  /**
   * @generated from field: string type = 1;
   */
  type = "";

  /**
   * @generated from field: google.protobuf.Duration duration = 2;
   */
  duration?: Duration;

  constructor(data?: PartialMessage<NotificationBoosterActive>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.notification.v1.NotificationBoosterActive";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "duration", kind: "message", T: Duration },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationBoosterActive {
    return new NotificationBoosterActive().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationBoosterActive {
    return new NotificationBoosterActive().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationBoosterActive {
    return new NotificationBoosterActive().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationBoosterActive | PlainMessage<NotificationBoosterActive> | undefined, b: NotificationBoosterActive | PlainMessage<NotificationBoosterActive> | undefined): boolean {
    return proto3.util.equals(NotificationBoosterActive, a, b);
  }
}

/**
 * Notify credits refilled.
 *
 * @generated from message gdx.gateway.web.notification.v1.NotificationCreditsRefillSuccess
 */
export class NotificationCreditsRefillSuccess extends Message<NotificationCreditsRefillSuccess> {
  /**
   * @generated from field: int64 current_amount = 1;
   */
  currentAmount = protoInt64.zero;

  constructor(data?: PartialMessage<NotificationCreditsRefillSuccess>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.notification.v1.NotificationCreditsRefillSuccess";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "current_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationCreditsRefillSuccess {
    return new NotificationCreditsRefillSuccess().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationCreditsRefillSuccess {
    return new NotificationCreditsRefillSuccess().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationCreditsRefillSuccess {
    return new NotificationCreditsRefillSuccess().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationCreditsRefillSuccess | PlainMessage<NotificationCreditsRefillSuccess> | undefined, b: NotificationCreditsRefillSuccess | PlainMessage<NotificationCreditsRefillSuccess> | undefined): boolean {
    return proto3.util.equals(NotificationCreditsRefillSuccess, a, b);
  }
}

/**
 * Notify credits updated.
 *
 * @generated from message gdx.gateway.web.notification.v1.NotificationCreditsUpdated
 */
export class NotificationCreditsUpdated extends Message<NotificationCreditsUpdated> {
  /**
   * @generated from field: int64 current_amount = 1;
   */
  currentAmount = protoInt64.zero;

  constructor(data?: PartialMessage<NotificationCreditsUpdated>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.notification.v1.NotificationCreditsUpdated";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "current_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationCreditsUpdated {
    return new NotificationCreditsUpdated().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationCreditsUpdated {
    return new NotificationCreditsUpdated().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationCreditsUpdated {
    return new NotificationCreditsUpdated().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationCreditsUpdated | PlainMessage<NotificationCreditsUpdated> | undefined, b: NotificationCreditsUpdated | PlainMessage<NotificationCreditsUpdated> | undefined): boolean {
    return proto3.util.equals(NotificationCreditsUpdated, a, b);
  }
}

/**
 * Notify credits refill failed.
 *
 * @generated from message gdx.gateway.web.notification.v1.NotificationCreditsRefillFail
 */
export class NotificationCreditsRefillFail extends Message<NotificationCreditsRefillFail> {
  constructor(data?: PartialMessage<NotificationCreditsRefillFail>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.notification.v1.NotificationCreditsRefillFail";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationCreditsRefillFail {
    return new NotificationCreditsRefillFail().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationCreditsRefillFail {
    return new NotificationCreditsRefillFail().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationCreditsRefillFail {
    return new NotificationCreditsRefillFail().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationCreditsRefillFail | PlainMessage<NotificationCreditsRefillFail> | undefined, b: NotificationCreditsRefillFail | PlainMessage<NotificationCreditsRefillFail> | undefined): boolean {
    return proto3.util.equals(NotificationCreditsRefillFail, a, b);
  }
}

/**
 * Notify subscription payment was a success.
 *
 * @generated from message gdx.gateway.web.notification.v1.NotificationSubscriptionPaymentSuccess
 */
export class NotificationSubscriptionPaymentSuccess extends Message<NotificationSubscriptionPaymentSuccess> {
  /**
   * @generated from field: string order_id = 1;
   */
  orderId = "";

  /**
   * @generated from field: string user_id = 2;
   */
  userId = "";

  /**
   * @generated from field: gdx.gateway.web.payment.v2.PackageIdentity package = 3;
   */
  package?: PackageIdentity;

  /**
   * @generated from field: google.protobuf.Timestamp expires_time = 4;
   */
  expiresTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Duration expires_duration = 5;
   */
  expiresDuration?: Duration;

  /**
   * @generated from field: string descriptor_text = 6;
   */
  descriptorText = "";

  constructor(data?: PartialMessage<NotificationSubscriptionPaymentSuccess>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.notification.v1.NotificationSubscriptionPaymentSuccess";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "package", kind: "message", T: PackageIdentity },
    { no: 4, name: "expires_time", kind: "message", T: Timestamp },
    { no: 5, name: "expires_duration", kind: "message", T: Duration },
    { no: 6, name: "descriptor_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationSubscriptionPaymentSuccess {
    return new NotificationSubscriptionPaymentSuccess().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationSubscriptionPaymentSuccess {
    return new NotificationSubscriptionPaymentSuccess().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationSubscriptionPaymentSuccess {
    return new NotificationSubscriptionPaymentSuccess().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationSubscriptionPaymentSuccess | PlainMessage<NotificationSubscriptionPaymentSuccess> | undefined, b: NotificationSubscriptionPaymentSuccess | PlainMessage<NotificationSubscriptionPaymentSuccess> | undefined): boolean {
    return proto3.util.equals(NotificationSubscriptionPaymentSuccess, a, b);
  }
}

/**
 * Notify subscription payment failed.
 *
 * @generated from message gdx.gateway.web.notification.v1.NotificationSubscriptionPaymentFailed
 */
export class NotificationSubscriptionPaymentFailed extends Message<NotificationSubscriptionPaymentFailed> {
  /**
   * @generated from field: string order_id = 1;
   */
  orderId = "";

  /**
   * @generated from field: string user_id = 2;
   */
  userId = "";

  /**
   * @generated from field: gdx.gateway.web.payment.v2.PackageIdentity package = 3;
   */
  package?: PackageIdentity;

  /**
   * @generated from field: string code = 4;
   */
  code = "";

  /**
   * @generated from field: string message = 5;
   */
  message = "";

  /**
   * @generated from field: string recommendation = 6;
   */
  recommendation = "";

  /**
   * @generated from field: google.protobuf.Timestamp next_charge_time = 7;
   */
  nextChargeTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Duration next_charge_duration = 8;
   */
  nextChargeDuration?: Duration;

  constructor(data?: PartialMessage<NotificationSubscriptionPaymentFailed>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.notification.v1.NotificationSubscriptionPaymentFailed";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "package", kind: "message", T: PackageIdentity },
    { no: 4, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "recommendation", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "next_charge_time", kind: "message", T: Timestamp },
    { no: 8, name: "next_charge_duration", kind: "message", T: Duration },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationSubscriptionPaymentFailed {
    return new NotificationSubscriptionPaymentFailed().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationSubscriptionPaymentFailed {
    return new NotificationSubscriptionPaymentFailed().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationSubscriptionPaymentFailed {
    return new NotificationSubscriptionPaymentFailed().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationSubscriptionPaymentFailed | PlainMessage<NotificationSubscriptionPaymentFailed> | undefined, b: NotificationSubscriptionPaymentFailed | PlainMessage<NotificationSubscriptionPaymentFailed> | undefined): boolean {
    return proto3.util.equals(NotificationSubscriptionPaymentFailed, a, b);
  }
}

/**
 * Notify power like send success.
 *
 * @generated from message gdx.gateway.web.notification.v1.NotificationSendPowerLikeSuccess
 */
export class NotificationSendPowerLikeSuccess extends Message<NotificationSendPowerLikeSuccess> {
  /**
   * @generated from field: string connection_id = 1;
   */
  connectionId = "";

  /**
   * @generated from field: string subject_id = 2;
   */
  subjectId = "";

  /**
   * @generated from field: string initiator_id = 4;
   */
  initiatorId = "";

  /**
   * @generated from field: gdx.gateway.web.notification.v1.NotificationSendPowerLikeSuccess.Source source = 3;
   */
  source = NotificationSendPowerLikeSuccess_Source.INVALID;

  constructor(data?: PartialMessage<NotificationSendPowerLikeSuccess>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.notification.v1.NotificationSendPowerLikeSuccess";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "connection_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "subject_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "initiator_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "source", kind: "enum", T: proto3.getEnumType(NotificationSendPowerLikeSuccess_Source) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationSendPowerLikeSuccess {
    return new NotificationSendPowerLikeSuccess().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationSendPowerLikeSuccess {
    return new NotificationSendPowerLikeSuccess().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationSendPowerLikeSuccess {
    return new NotificationSendPowerLikeSuccess().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationSendPowerLikeSuccess | PlainMessage<NotificationSendPowerLikeSuccess> | undefined, b: NotificationSendPowerLikeSuccess | PlainMessage<NotificationSendPowerLikeSuccess> | undefined): boolean {
    return proto3.util.equals(NotificationSendPowerLikeSuccess, a, b);
  }
}

/**
 * Enumerates sources of power like.
 *
 * @generated from enum gdx.gateway.web.notification.v1.NotificationSendPowerLikeSuccess.Source
 */
export enum NotificationSendPowerLikeSuccess_Source {
  /**
   * @generated from enum value: SOURCE_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: SOURCE_ORGANIC = 1;
   */
  ORGANIC = 1,

  /**
   * @generated from enum value: SOURCE_ENGAGEMENT = 2;
   */
  ENGAGEMENT = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(NotificationSendPowerLikeSuccess_Source)
proto3.util.setEnumType(NotificationSendPowerLikeSuccess_Source, "gdx.gateway.web.notification.v1.NotificationSendPowerLikeSuccess.Source", [
  { no: 0, name: "SOURCE_INVALID" },
  { no: 1, name: "SOURCE_ORGANIC" },
  { no: 2, name: "SOURCE_ENGAGEMENT" },
]);

/**
 * Notify power like send fail.
 *
 * @generated from message gdx.gateway.web.notification.v1.NotificationSendPowerLikeFail
 */
export class NotificationSendPowerLikeFail extends Message<NotificationSendPowerLikeFail> {
  /**
   * @generated from field: string connection_id = 1;
   */
  connectionId = "";

  /**
   * @generated from field: string subject_id = 2;
   */
  subjectId = "";

  constructor(data?: PartialMessage<NotificationSendPowerLikeFail>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.notification.v1.NotificationSendPowerLikeFail";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "connection_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "subject_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationSendPowerLikeFail {
    return new NotificationSendPowerLikeFail().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationSendPowerLikeFail {
    return new NotificationSendPowerLikeFail().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationSendPowerLikeFail {
    return new NotificationSendPowerLikeFail().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationSendPowerLikeFail | PlainMessage<NotificationSendPowerLikeFail> | undefined, b: NotificationSendPowerLikeFail | PlainMessage<NotificationSendPowerLikeFail> | undefined): boolean {
    return proto3.util.equals(NotificationSendPowerLikeFail, a, b);
  }
}

/**
 * Notify sexual compatibility promo.
 *
 * @generated from message gdx.gateway.web.notification.v1.NotificationSexualCompatibilityPromo
 */
export class NotificationSexualCompatibilityPromo extends Message<NotificationSexualCompatibilityPromo> {
  /**
   * @generated from field: string subject_id = 1;
   */
  subjectId = "";

  /**
   * @generated from field: string subject_name = 2;
   */
  subjectName = "";

  /**
   * @generated from field: gdx.gateway.web.profile.v1.ProfilePhoto avatar = 3;
   */
  avatar?: ProfilePhoto;

  constructor(data?: PartialMessage<NotificationSexualCompatibilityPromo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.notification.v1.NotificationSexualCompatibilityPromo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "subject_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "subject_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "avatar", kind: "message", T: ProfilePhoto },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationSexualCompatibilityPromo {
    return new NotificationSexualCompatibilityPromo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationSexualCompatibilityPromo {
    return new NotificationSexualCompatibilityPromo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationSexualCompatibilityPromo {
    return new NotificationSexualCompatibilityPromo().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationSexualCompatibilityPromo | PlainMessage<NotificationSexualCompatibilityPromo> | undefined, b: NotificationSexualCompatibilityPromo | PlainMessage<NotificationSexualCompatibilityPromo> | undefined): boolean {
    return proto3.util.equals(NotificationSexualCompatibilityPromo, a, b);
  }
}

/**
 * Notify astro compatibility promo.
 *
 * @generated from message gdx.gateway.web.notification.v1.NotificationAstroCompatibilityPromo
 */
export class NotificationAstroCompatibilityPromo extends Message<NotificationAstroCompatibilityPromo> {
  /**
   * @generated from field: string subject_id = 1;
   */
  subjectId = "";

  /**
   * @generated from field: string subject_name = 2;
   */
  subjectName = "";

  /**
   * @generated from field: gdx.gateway.web.profile.v1.ProfilePhoto avatar = 3;
   */
  avatar?: ProfilePhoto;

  constructor(data?: PartialMessage<NotificationAstroCompatibilityPromo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.notification.v1.NotificationAstroCompatibilityPromo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "subject_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "subject_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "avatar", kind: "message", T: ProfilePhoto },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationAstroCompatibilityPromo {
    return new NotificationAstroCompatibilityPromo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationAstroCompatibilityPromo {
    return new NotificationAstroCompatibilityPromo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationAstroCompatibilityPromo {
    return new NotificationAstroCompatibilityPromo().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationAstroCompatibilityPromo | PlainMessage<NotificationAstroCompatibilityPromo> | undefined, b: NotificationAstroCompatibilityPromo | PlainMessage<NotificationAstroCompatibilityPromo> | undefined): boolean {
    return proto3.util.equals(NotificationAstroCompatibilityPromo, a, b);
  }
}

/**
 * Notify sexual compatibility.
 *
 * @generated from message gdx.gateway.web.notification.v1.NotificationSexualCompatibility
 */
export class NotificationSexualCompatibility extends Message<NotificationSexualCompatibility> {
  /**
   * @generated from field: string subject_id = 1;
   */
  subjectId = "";

  /**
   * @generated from field: string subject_name = 2;
   */
  subjectName = "";

  /**
   * @generated from field: gdx.gateway.web.profile.v1.ProfilePhoto avatar = 3;
   */
  avatar?: ProfilePhoto;

  /**
   * @generated from field: bool is_online = 4;
   */
  isOnline = false;

  constructor(data?: PartialMessage<NotificationSexualCompatibility>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.notification.v1.NotificationSexualCompatibility";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "subject_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "subject_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "avatar", kind: "message", T: ProfilePhoto },
    { no: 4, name: "is_online", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationSexualCompatibility {
    return new NotificationSexualCompatibility().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationSexualCompatibility {
    return new NotificationSexualCompatibility().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationSexualCompatibility {
    return new NotificationSexualCompatibility().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationSexualCompatibility | PlainMessage<NotificationSexualCompatibility> | undefined, b: NotificationSexualCompatibility | PlainMessage<NotificationSexualCompatibility> | undefined): boolean {
    return proto3.util.equals(NotificationSexualCompatibility, a, b);
  }
}

/**
 * Notify astro compatibility.
 *
 * @generated from message gdx.gateway.web.notification.v1.NotificationAstroCompatibility
 */
export class NotificationAstroCompatibility extends Message<NotificationAstroCompatibility> {
  /**
   * @generated from field: string subject_id = 1;
   */
  subjectId = "";

  /**
   * @generated from field: string subject_name = 2;
   */
  subjectName = "";

  /**
   * @generated from field: gdx.gateway.web.profile.v1.ProfilePhoto avatar = 3;
   */
  avatar?: ProfilePhoto;

  /**
   * @generated from field: bool is_online = 4;
   */
  isOnline = false;

  constructor(data?: PartialMessage<NotificationAstroCompatibility>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.notification.v1.NotificationAstroCompatibility";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "subject_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "subject_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "avatar", kind: "message", T: ProfilePhoto },
    { no: 4, name: "is_online", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationAstroCompatibility {
    return new NotificationAstroCompatibility().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationAstroCompatibility {
    return new NotificationAstroCompatibility().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationAstroCompatibility {
    return new NotificationAstroCompatibility().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationAstroCompatibility | PlainMessage<NotificationAstroCompatibility> | undefined, b: NotificationAstroCompatibility | PlainMessage<NotificationAstroCompatibility> | undefined): boolean {
    return proto3.util.equals(NotificationAstroCompatibility, a, b);
  }
}

/**
 * Arrived when credits feature is active ( e.g. gift, booster, power-like, ... ).
 *
 * @generated from message gdx.gateway.web.notification.v1.NotificationCreditsFeatureSuccess
 */
export class NotificationCreditsFeatureSuccess extends Message<NotificationCreditsFeatureSuccess> {
  /**
   * @generated from field: gdx.market.v1.FeatureType feature_type = 1;
   */
  featureType = FeatureType.INVALID;

  constructor(data?: PartialMessage<NotificationCreditsFeatureSuccess>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.notification.v1.NotificationCreditsFeatureSuccess";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "feature_type", kind: "enum", T: proto3.getEnumType(FeatureType) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationCreditsFeatureSuccess {
    return new NotificationCreditsFeatureSuccess().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationCreditsFeatureSuccess {
    return new NotificationCreditsFeatureSuccess().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationCreditsFeatureSuccess {
    return new NotificationCreditsFeatureSuccess().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationCreditsFeatureSuccess | PlainMessage<NotificationCreditsFeatureSuccess> | undefined, b: NotificationCreditsFeatureSuccess | PlainMessage<NotificationCreditsFeatureSuccess> | undefined): boolean {
    return proto3.util.equals(NotificationCreditsFeatureSuccess, a, b);
  }
}

/**
 * Arrived when credits feature can't be active
 * ( e.g. free limit has been exhausted, insufficient credits in case of autorefill is active ).
 *
 * @generated from message gdx.gateway.web.notification.v1.NotificationCreditsFeatureFail
 */
export class NotificationCreditsFeatureFail extends Message<NotificationCreditsFeatureFail> {
  /**
   * @generated from field: gdx.market.v1.FeatureType feature_type = 1;
   */
  featureType = FeatureType.INVALID;

  constructor(data?: PartialMessage<NotificationCreditsFeatureFail>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.notification.v1.NotificationCreditsFeatureFail";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "feature_type", kind: "enum", T: proto3.getEnumType(FeatureType) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationCreditsFeatureFail {
    return new NotificationCreditsFeatureFail().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationCreditsFeatureFail {
    return new NotificationCreditsFeatureFail().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationCreditsFeatureFail {
    return new NotificationCreditsFeatureFail().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationCreditsFeatureFail | PlainMessage<NotificationCreditsFeatureFail> | undefined, b: NotificationCreditsFeatureFail | PlainMessage<NotificationCreditsFeatureFail> | undefined): boolean {
    return proto3.util.equals(NotificationCreditsFeatureFail, a, b);
  }
}

/**
 * Arrived when feature limit is exceeded.
 * (only for feature type FEATURE_TYPE_PHOTO_REQUEST)
 *
 * @generated from message gdx.gateway.web.notification.v1.NotificationFeatureLimit
 */
export class NotificationFeatureLimit extends Message<NotificationFeatureLimit> {
  /**
   * @generated from field: gdx.market.v1.FeatureType feature_type = 1;
   */
  featureType = FeatureType.INVALID;

  constructor(data?: PartialMessage<NotificationFeatureLimit>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.notification.v1.NotificationFeatureLimit";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "feature_type", kind: "enum", T: proto3.getEnumType(FeatureType) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationFeatureLimit {
    return new NotificationFeatureLimit().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationFeatureLimit {
    return new NotificationFeatureLimit().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationFeatureLimit {
    return new NotificationFeatureLimit().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationFeatureLimit | PlainMessage<NotificationFeatureLimit> | undefined, b: NotificationFeatureLimit | PlainMessage<NotificationFeatureLimit> | undefined): boolean {
    return proto3.util.equals(NotificationFeatureLimit, a, b);
  }
}

/**
 * Notify that user has undelivered conversions.
 *
 * @generated from message gdx.gateway.web.notification.v1.NotificationNewUndeliveredConversions
 */
export class NotificationNewUndeliveredConversions extends Message<NotificationNewUndeliveredConversions> {
  /**
   * @generated from field: google.protobuf.Timestamp since_time = 1;
   */
  sinceTime?: Timestamp;

  constructor(data?: PartialMessage<NotificationNewUndeliveredConversions>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.notification.v1.NotificationNewUndeliveredConversions";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "since_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationNewUndeliveredConversions {
    return new NotificationNewUndeliveredConversions().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationNewUndeliveredConversions {
    return new NotificationNewUndeliveredConversions().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationNewUndeliveredConversions {
    return new NotificationNewUndeliveredConversions().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationNewUndeliveredConversions | PlainMessage<NotificationNewUndeliveredConversions> | undefined, b: NotificationNewUndeliveredConversions | PlainMessage<NotificationNewUndeliveredConversions> | undefined): boolean {
    return proto3.util.equals(NotificationNewUndeliveredConversions, a, b);
  }
}

/**
 * Notify when possibility changed.
 *
 * @generated from message gdx.gateway.web.notification.v1.NotificationPossibilitiesUpdated
 */
export class NotificationPossibilitiesUpdated extends Message<NotificationPossibilitiesUpdated> {
  /**
   * all actual possibilities
   *
   * @generated from field: repeated gdx.gateway.web.possibilities.v1.Possibility possibilities = 1;
   */
  possibilities: Possibility[] = [];

  constructor(data?: PartialMessage<NotificationPossibilitiesUpdated>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.notification.v1.NotificationPossibilitiesUpdated";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "possibilities", kind: "message", T: Possibility, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationPossibilitiesUpdated {
    return new NotificationPossibilitiesUpdated().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationPossibilitiesUpdated {
    return new NotificationPossibilitiesUpdated().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationPossibilitiesUpdated {
    return new NotificationPossibilitiesUpdated().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationPossibilitiesUpdated | PlainMessage<NotificationPossibilitiesUpdated> | undefined, b: NotificationPossibilitiesUpdated | PlainMessage<NotificationPossibilitiesUpdated> | undefined): boolean {
    return proto3.util.equals(NotificationPossibilitiesUpdated, a, b);
  }
}

/**
 * Notify when possibility purchased successfully.
 *
 * @generated from message gdx.gateway.web.notification.v1.NotificationPossibilitiesPurchasedSuccessfully
 */
export class NotificationPossibilitiesPurchasedSuccessfully extends Message<NotificationPossibilitiesPurchasedSuccessfully> {
  /**
   * only purchased possibilities
   *
   * @generated from field: repeated gdx.gateway.web.possibilities.v1.Possibility possibilities = 1;
   */
  possibilities: Possibility[] = [];

  constructor(data?: PartialMessage<NotificationPossibilitiesPurchasedSuccessfully>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.notification.v1.NotificationPossibilitiesPurchasedSuccessfully";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "possibilities", kind: "message", T: Possibility, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationPossibilitiesPurchasedSuccessfully {
    return new NotificationPossibilitiesPurchasedSuccessfully().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationPossibilitiesPurchasedSuccessfully {
    return new NotificationPossibilitiesPurchasedSuccessfully().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationPossibilitiesPurchasedSuccessfully {
    return new NotificationPossibilitiesPurchasedSuccessfully().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationPossibilitiesPurchasedSuccessfully | PlainMessage<NotificationPossibilitiesPurchasedSuccessfully> | undefined, b: NotificationPossibilitiesPurchasedSuccessfully | PlainMessage<NotificationPossibilitiesPurchasedSuccessfully> | undefined): boolean {
    return proto3.util.equals(NotificationPossibilitiesPurchasedSuccessfully, a, b);
  }
}

